"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormStore = void 0;
var services_1 = require("../services");
var form_edit_state_1 = require("../state/form.edit.state");
var FormStore = /** @class */ (function () {
    function FormStore() {
        this.edits = {};
    }
    FormStore.prototype.edit = function (form) {
        var currentEdit = this.edits[form.version];
        if (currentEdit == null) {
            currentEdit = this.edits[form.version] = new form_edit_state_1.FormEditState(form);
        }
        return currentEdit;
    };
    FormStore.prototype.clearEdit = function (form) {
        delete this.edits[form.version];
    };
    FormStore.prototype.get = function (version) {
        var rest = services_1.Services.Department.rest;
        return rest.form('version', version).value;
    };
    FormStore.prototype.fetch = function (version) {
        var rest = services_1.Services.Department.rest;
        return rest.form('version', version).fetch();
    };
    /**
     * @deprecated Used by legacy mapsight code
     */
    FormStore.prototype.fetchJSON = function (version) {
        var rest = services_1.Services.Department.rest;
        return rest.Form.getByRevision(version).fetch();
    };
    /**
   * @deprecated Used by legacy mapsight code
   */
    FormStore.prototype.saveJSON = function (form) {
        var rest = services_1.Services.Department.rest;
        return rest.save(rest.Objects.Form, form);
    };
    FormStore.prototype.exists = function (version) {
        var rest = services_1.Services.Department.rest;
        var fetchable = rest.form('version', version);
        return fetchable.isFetching || fetchable.value != null;
    };
    return FormStore;
}());
exports.FormStore = FormStore;
//# sourceMappingURL=form.store.js.map